import React, {useState} from 'react';
import { StoreImage } from './store-image';
import MapPin from './map-pin';
import directionUrl from '../store/direction-url';
import splitHours from '../store/split-hours';

export function MobileExpandedStore({store, origin, toggleExpandedStore, isInPostStoreLocatorRebrandEnabled}) {
  const [openingHoursExpanded, setOpeningHoursExpanded] = useState(true);

  let directions_url = directionUrl(origin, store);
  return (
    <div className="mobile-expanded-store">
      <StoreImage imageUrl={store.store_image_url} />

      <div className="content">
        <a className="back-to-store-locator-link" onClick={toggleExpandedStore}>
          <img src="/assets/2017/icons/yodel-chevron.svg" alt="yodel-back-chevron" /> Back to store locator
        </a>

        <h1 className="store-name"><img src={new MapPin({...store, selected: true}, isInPostStoreLocatorRebrandEnabled).icon()} /> {store?.name}</h1>
        <p className="address"><img src="/assets/store-locator/yodel-map-icon.svg" /> {store?.address}</p>
        <div className="directions-distance-wrapper">
          <a className="directions" target="_blank" href={directions_url}>Get Directions</a>
          <span className="distance">{store.distance.toFixed(1)} miles</span>
        </div>

        {store?.print_in_store &&
          (
            <div className="services">
              <img src="/assets/store-locator/yodel-printer-icon.svg" alt="print-in-store-icon"
                className="print-in-store-image"
                title={isInPostStoreLocatorRebrandEnabled ? 'Print at shop is available here' : 'Print in store is available here'} />
              <span className="print-in-store-text">{isInPostStoreLocatorRebrandEnabled ? 'Print at shop' : 'Print in store'}</span>
            </div>
          )
        }

        <div className="opening-times-container">
          <div className="opening-times-icon-text">
            <img src="/assets/store-locator/opening_times.svg" alt="address-icon" className='store-detail-image -yodel-hour-image' />
            <span className="open-until" onClick={() => { setOpeningHoursExpanded(!openingHoursExpanded) }}>
              {store.closing_message}
              <img src="/assets/store-locator/arrow_down.svg" alt="open-hours-image" className={openingHoursExpanded ? "flip-arrow flip-arrow--turned" : "flip-arrow"} />
            </span>
          </div>

          {openingHoursExpanded &&
            <div className="opening-time -yodel">
              {store.opening_hours && store.opening_hours.map(oh =>
                (<div itemProp="openingHours" className={(store.todayDaysName === oh.days_short) ? 'opening-hours-each -active-day' : 'opening-hours-each'} key={oh.days}>
                  <span className='opening-hours-days'>{oh.days}</span>
                  {!['24h', 'closed'].includes(oh.hours) ? (
                    <div>
                      <span className='opening-hours-hours'>{splitHours(oh.hours)[0]}</span>
                      <span> - </span>
                      <span className='opening-hours-hours'>{splitHours(oh.hours)[1]}</span>
                      <meta itemProp="openingHours" content={oh.days_short + " " + splitHours(oh.hours)[0] + "-" + splitHours(oh.hours)[1]} />
                    </div>
                  ) : (
                    <span className='opening-hours-hours'>{oh.hours}</span>
                  )}
                </div>)
            )}
            </div>
          }
        </div>

        <a href="/returns" target="_blank" className="return-a-parcel-link">Return a parcel</a>
      </div>
    </div>
  );
}
